var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    { 'show-nav' : _vm.visibleNav && _vm.$route.name !== 'index' },
    { 'only-arrow' : _vm.pageTitle === ' ' }
  ],attrs:{"id":"nav"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.pageTitle)?_c('simple-navigation',{attrs:{"pageTitle":_vm.pageTitle}}):_c('default-navigation')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }